import { render, staticRenderFns } from "./DailyForms.vue?vue&type=template&id=f206e00e&"
import script from "./DailyForms.vue?vue&type=script&lang=js&"
export * from "./DailyForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports